import {initializeErrorReporting, reportHandledError} from './app/cbet/service/error-reporting.service';
import { enableProdMode, provideZoneChangeDetection } from '@angular/core';
import { platformBrowser } from '@angular/platform-browser';

import { AppModule } from './app/app.module';
import { environment } from './environments/environment';
import { aplicarPlantilla } from './app/cbet/config/plantilla';

initializeErrorReporting();
aplicarPlantilla(document);

if (environment.production) {
  enableProdMode();
}

enableProdMode();
platformBrowser()
    .bootstrapModule(AppModule, { applicationProviders: [provideZoneChangeDetection()], })
    .catch((err) => { reportHandledError(err, 'angular.bootstrap'); console.error(err); });
